import React from "react";
import "./Gallery.css";
import Seo from "../components/Seo";

const gallerySections = [
  {
    title: "Before & After",
    key: "before-after",
    pairs: [
      {
        before: "/images/gallery/before-after/ba-01-before.png",
        after: "/images/gallery/before-after/ba-01-after.png",
        beforeAlt: "Before interior repaint in Kingwood TX — walls and trim",
        afterAlt: "After interior repaint in Kingwood TX — clean lines and durable finish",
      },
      {
        before: "/images/gallery/before-after/ba-02-before.png",
        after: "/images/gallery/before-after/ba-02-after.png",
        beforeAlt: "Before apartment repaint in Kingwood TX — rental turnover",
        afterAlt: "After apartment repaint in Kingwood TX — refreshed for new tenants",
      },
      {
        before: "/images/gallery/before-after/ba-03-before.jpeg",
        after: "/images/gallery/before-after/ba-03-after.jpg",
        beforeAlt: "Before exterior repaint in Kingwood TX — weathered siding",
        afterAlt: "After exterior repaint in Kingwood TX — updated siding and trim",
      },
    ],
  },
];

const singleSections = [
  {
    title: "Detail Work (Clean Lines)",
    key: "details",
    images: [
      { src: "/images/gallery/details/detail-01.jpeg", alt: "Detail work — clean cut line at ceiling corner" },
      { src: "/images/gallery/details/detail-02.jpeg", alt: "Detail work — crisp trim and wall separation" },
      { src: "/images/gallery/details/detail-03.jpeg", alt: "Detail work — smooth cabinet and wall finish" },
      { src: "/images/gallery/details/detail-04.jpg", alt: "Detail work — precise edging around fixtures" },
    ],
  },
  {
    title: "Exterior Projects",
    key: "exterior",
    images: [
      { src: "/images/gallery/exterior/ext-01.jpeg", alt: "Exterior house painting — refreshed siding and trim" },
      { src: "/images/gallery/exterior/ext-02.jpeg", alt: "Exterior repaint — updated fascia and doors" },
      { src: "/images/gallery/exterior/ext-03.jpeg", alt: "Exterior painting — clean lines on shutters and siding" },
    ],
  },
  {
    title: "Prep & Protection",
    key: "prep",
    images: [
      { src: "/images/gallery/prep/prep-01.jpeg", alt: "Prep work — floors protected and masking complete" },
      { src: "/images/gallery/prep/prep-02.jpeg", alt: "Prep work — taped edges and covered surfaces" },
      { src: "/images/gallery/prep/prep-03.jpeg", alt: "Prep work — site protected before painting begins" },
    ],
  },
];

const Gallery = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "PaintingContractor",
    name: "J3 Innovations",
    areaServed: ["Kingwood", "Houston", "TX"],
    url: "https://www.j3innovations.com/gallery",
    description: "Painting project gallery for residential and commercial work in Kingwood and Houston.",
  };

  return (
    <div className="page-shell" data-theme="gallery">
      <Seo
        title="Painting Project Gallery — Kingwood & Houston | J3 Innovations"
        description="See before/after, detail, exterior, and prep photos from J3 Innovations painting projects in Kingwood and Houston. Residential, rentals, and commercial."
        canonicalPath="/gallery"
        image="/images/gallery/before-after/ba-01-after.jpg"
        structuredData={structuredData}
      />
      <div className="page-wrap">
        <div className="page-hero">
          <p className="page-eyebrow">Gallery</p>
          <h1>Painting Project Gallery — Kingwood &amp; Houston</h1>
          <p className="lead">
            Before/after transformations, clean-line details, exterior updates, and the prep work that keeps homes and
            rentals protected.
          </p>
        </div>

        {gallerySections.map((section) => (
          <div className="section-block" key={section.key}>
            <h2>{section.title}</h2>
            <div className="pair-grid">
              {section.pairs.map((pair, idx) => (
                <div className="pair" key={`${section.key}-${idx}`}>
                  <figure className="gallery-card">
                    <img src={pair.before} alt={pair.beforeAlt} />
                    <figcaption>Before</figcaption>
                  </figure>
                  <figure className="gallery-card">
                    <img src={pair.after} alt={pair.afterAlt} />
                    <figcaption>After</figcaption>
                  </figure>
                </div>
              ))}
            </div>
          </div>
        ))}

        {singleSections.map((section) => (
          <div className="section-block" key={section.key}>
            <h2>{section.title}</h2>
            <div className="gallery-grid">
              {section.images.map((img) => (
                <figure className="gallery-card" key={img.src}>
                  <img src={img.src} alt={img.alt} />
                  <figcaption>{img.alt}</figcaption>
                </figure>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
